import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/meetix-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0fd97a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "home-txt" }
const _hoisted_6 = { class: "icon-container" }
const _hoisted_7 = { class: "icon-container" }
const _hoisted_8 = { class: "icon-container" }
const _hoisted_9 = { class: "icon-container" }
const _hoisted_10 = { class: "icon-container" }
const _hoisted_11 = { class: "icon-container" }
const _hoisted_12 = { class: "icon-container" }
const _hoisted_13 = { class: "icon-container" }
const _hoisted_14 = { class: "icon-container" }
const _hoisted_15 = { class: "home-txt" }
const _hoisted_16 = { class: "home-txt" }
const _hoisted_17 = { class: "icon-container" }
const _hoisted_18 = { class: "home-txt" }
const _hoisted_19 = { class: "icon-container" }
const _hoisted_20 = { class: "home-txt" }
const _hoisted_21 = { class: "icon-container" }
const _hoisted_22 = { class: "home-txt" }
const _hoisted_23 = { class: "icon-container" }
const _hoisted_24 = { class: "home-txt" }
const _hoisted_25 = {
  class: "trigger",
  style: {"margin-left":"16px"}
}
const _hoisted_26 = {
  key: 0,
  class: "header-img-container"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "header-img",
  alt: "meetix-image"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_ApartmentOutlined = _resolveComponent("ApartmentOutlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_DesktopOutlined = _resolveComponent("DesktopOutlined")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_LikeOutlined = _resolveComponent("LikeOutlined")!
  const _component_LineChartOutlined = _resolveComponent("LineChartOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    style: {"height":"100vh","overflow":"hidden"},
    class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"]),
      _createVNode(_component_a_config_provider, {
        theme: {
      token: {
        colorPrimary: _ctx.themeTemplate.primaryColor,
        fontFamily: 'Exo 2',
      },

      components: {
        Menu: {
          colorItemBgHover: _ctx.$secondaryColor,
          colorItemBgSelected: _ctx.$secondaryColor,
          colorItemTextSelected: _ctx.$primaryColor,
        },
      }
      
      }
      }, null, 8, ["theme"]),
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        "onUpdate:collapsed": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.collapsed) = $event)),
        trigger: null,
        collapsible: "",
        width: _ctx.siderWidth,
        class: "layout-sider"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.collapsed && _ctx.$logo !=='nologo' )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$logo,
                    class: "logo-img-collapsed",
                    alt: "meetix-image",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/', '0')))
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              (!_ctx.collapsed  && _ctx.$logo !=='nologo' )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.$logo,
                    class: "logo-img",
                    alt: "meetix-image",
                    width: "75%",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigatePage('/', '0')))
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.collapsed && _ctx.$logo ==='nologo' )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _imports_0,
                    class: "logo-img-collapsed",
                    alt: "meetix-image",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigatePage('/', '0')))
                  }))
                : _createCommentVNode("", true),
              (!_ctx.collapsed  && _ctx.$logo ==='nologo' )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: _imports_0,
                    class: "logo-img",
                    alt: "meetix-image",
                    width: "75%",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigatePage('/', '0')))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_a_menu, {
              selectedKeys: _ctx.selectedKeys,
              "onUpdate:selectedKeys": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedKeys) = $event)),
              mode: "inline",
              class: "sider-menu"
            }, {
              default: _withCtx(() => [
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "icon-container",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigatePage('/','0')))
                        }, [
                          _createVNode(_component_HomeOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Meet.Dashboard')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "1" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_ApartmentOutlined, { class: "home-icon" }),
                            _withDirectives(_createElementVNode("span", { class: "home-txt" }, _toDisplayString(_ctx.t('Meet.Rooms')), 513), [
                              [_vShow, !_ctx.collapsed]
                            ])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, {
                          key: "1-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigatePage('/rooms','1-1')))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('Meet.Rooms')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, {
                          key: "1-2",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigatePage('/locations','1-2')))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('Meet.Locations')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_sub_menu, { key: "2" }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_CalendarOutlined, { class: "home-icon" }),
                        _withDirectives(_createElementVNode("span", { class: "home-txt" }, _toDisplayString(_ctx.t('Meet.Meetings')), 513), [
                          [_vShow, !_ctx.collapsed]
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      key: "2-1",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigatePage('/meetings','2-1')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('Meet.Meetings')), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: "2-2",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigatePage('/meeting-requests','2-2')))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('Meet.ReservationRequests')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                      ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "2-3" }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t('Meet.InternalRequests')), 1)
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, {
                              key: "3-3-1",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigatePage('/service-requests','3-3-1'))),
                              class: "submenu-container"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t('Meet.Services')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_item, {
                              key: "3-3-2",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navigatePage('/equipment-requests','3-3-2'))),
                              class: "submenu-container"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "icon-container",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigatePage('/equipments','3')))
                        }, [
                          _createVNode(_component_DesktopOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "icon-container",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigatePage('/services','4')))
                        }, [
                          _createVNode(_component_SettingOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('Meet.Services')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "5",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigatePage('/kiosk','5')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_DesktopOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('Meet.Kiosk')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "6",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navigatePage('/users','6')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_TeamOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('Meet.Users')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "7",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navigatePage('/feedback','7')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_LikeOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('Meet.FeedBack')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "8",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigatePage('/statistics','8')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_LineChartOutlined, { class: "home-icon" }),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t('Meet.statistics')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "9" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "icon-container",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.navigatePage('/settings','9')))
                        }, [
                          _createVNode(_component_SettingOutlined),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t('Meet.Settings')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["selectedKeys"])
          ])
        ]),
        _: 1
      }, 8, ["collapsed", "width"]),
      _createVNode(_component_a_layout, { style: {"overflow-y":"auto"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { class: "layout-header" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                (_ctx.collapsed)
                  ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                      key: 0,
                      onClick: _cache[20] || (_cache[20] = () => (_ctx.collapsed = !_ctx.collapsed))
                    }))
                  : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                      key: 1,
                      onClick: _cache[21] || (_cache[21] = () => (_ctx.collapsed = !_ctx.collapsed))
                    }))
              ]),
              (_ctx.$logo !=='nologo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.locale === 'ar' ? 'avatar-container-rtl' : 'avatar-container'])
              }, [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_dropdown, { class: "lang-drop" }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, {
                              key: "1",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setLanguage('fr')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.French')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_item, {
                              key: "2",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setLanguage('ar')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.Arabic')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_item, {
                              key: "3",
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setLanguage('en')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.English')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { class: "drop-btn" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currentLanguageText) + " ", 1),
                            _createVNode(_component_DownOutlined)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, {
                              key: "0",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.navigatePage('/profile','')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.Profile')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_divider),
                            _createVNode(_component_a_menu_item, {
                              key: "1",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.logout()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.Logout')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "ant-dropdown-link",
                          onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          (_ctx.state.user.photo===null)
                            ? (_openBlock(), _createBlock(_component_a_avatar, {
                                key: 0,
                                size: 35,
                                class: "avatar-icon"
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_UserOutlined)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.state.user.photo!==null)
                            ? (_openBlock(), _createBlock(_component_a_avatar, {
                                key: 1,
                                size: 35,
                                src: _ctx.state.user.photo
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, {
            style: { margin: '24px 16px', padding: '24px', background: '#fff', minHeight: 'auto' },
            class: _normalizeClass({ 'dashboard-bg': _ctx.noBgRoute})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_layout_footer, { class: "footer" }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.t('Meet.Copyright')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}